const firebase_config = {
    apiKey: "AIzaSyBC_pE3FtOy8DH6r_E538iFETYclPKeopk",
    authDomain: "kidstthink.firebaseapp.com",
    databaseURL: "https://kidstthink.firebaseio.com",
    projectId: "kidstthink",
    storageBucket: "kidstthink.appspot.com",
    messagingSenderId: "1052197370502"
};

export default firebase_config


// WEBPACK FOOTER //
// ./src/firebase_config.js